import { POINTS_TYPE } from '@/constants/accelerationTable'

import type { AccelerationFormPointsValues, CreateCampaignPointsPayload } from '../AccelerationForm.types'

export const serializeAccelerationPointsForApi = (
  pointsData: AccelerationFormPointsValues
): CreateCampaignPointsPayload => {
  const basePayload = {
    description: pointsData.description,
    type: pointsData.type
  }

  if (pointsData.type === POINTS_TYPE.DEFAULT) {
    return {
      ...basePayload,
      startDate: pointsData.startDate,
      endDate: pointsData.endDate
    }
  }

  if (pointsData.type === POINTS_TYPE.DAYS_CALENDAR && pointsData.countOfDays) {
    return {
      ...basePayload,
      countOfDays: Number(pointsData.countOfDays)
    }
  }

  return basePayload
}
